import type { ScaleBand } from 'd3-scale';

import { isVertical } from './layout.js';
import type { Point } from '../../core/types/point.js';
import { scaleBandInvert } from '../../core/utils/scale.js';
import type { DimensionXYPoint } from '../types/categorical-bar-chart-data.js';
import type { Layout } from '../types/categorical-bar-chart.js';

export const TOOLTIP_DISTANCE_THRESHOLD = 32;
/**
 * Retrieve the closest point in a grouped chart
 * considering the corresponding category and dimension.
 *
 * @param layout - layout mode of the chart
 * @param mousePosition - mouse coordinate
 * @param closestDimensionPoints - closest dimension points
 * @param categoryScale - category scale
 * @param dimensionScale - dimension scale
 *
 * @returns closest point of the mouse coordinate in a grouped chart
 */
export function findClosestPointInGroupedChart(
  layout: Layout,
  mousePosition: Point,
  closestDimensionPoints: DimensionXYPoint[],
  categoryScale: ScaleBand<string>,
  dimensionScale: ScaleBand<string>,
): DimensionXYPoint | undefined {
  const mouseCoordinate = isVertical(layout)
    ? mousePosition.x
    : mousePosition.y;
  const closestCategory = scaleBandInvert(categoryScale)(mouseCoordinate);
  const categoryCoord = categoryScale(closestCategory) ?? 0;
  const closestDimension = scaleBandInvert(dimensionScale)(
    mouseCoordinate - categoryCoord,
  );

  return closestDimensionPoints.find(
    (dimension) => closestDimension === dimension.datapoint.name,
  );
}
